import { computed, provide, ref, createApp, App, watch } from 'vue'
import { createPinia } from "pinia"
import {
  createRouter, 
  createWebHistory,
  useRoute,
  RouteParams,
  RouteLocationNormalizedLoaded,
  RouteRecordName,
} from 'vue-router'
import { useI18n } from 'vue-i18n'
import createAppRouter from "@/router"
import install from '@/install'
import i18n from "./i18n"
import HelloWorld from './components/HelloWorld.vue'
import Components from '@/components/index'
import Modules from '@/modules/index'
import Plugins from '@/plugins/'

type CreateApplication = {
  createApp: typeof createApp
  createRouter: typeof createRouter
  createWebHistory: typeof createWebHistory
  createPinia: typeof createPinia
}

export function createApplication({
  createApp,
  createRouter: createRouterInstance,
  createWebHistory,
  createPinia,
}: CreateApplication): App {
  const app = createApp({
    setup() {

      // console.log('createApplication в app.ts')

      const route: RouteLocationNormalizedLoaded = useRoute()
      const { t: $t } = useI18n()

      const updatedTitle = ref<{ title: string; subTitle?: string } | null>(
        null
      )

      const currentTitle = computed(() => {
        if (updatedTitle.value?.title) {
          return updatedTitle.value
        }
        return 'function' === typeof route.meta.title
          ? route.meta.title?.(route.params as RouteParams) ||
              $t('Cars from containers')
          : route.meta.title || $t('Cars from containers')
      })

      // console.log('currentTitle', currentTitle)
      // добавляем title из роута (если он там есть) или его дефолтное значение
      // в общий доступ для компонентов через вызов inject
      provide('currentTitle', currentTitle)
      provide(
        'updateCurrentTitle',
        (title: { title: string; subTitle?: string } | null) => {
          // console.log(title, 'updateCurrentTitle');
          updatedTitle.value = title
        }
      )

      // custom history.back logic
      const routeFromName = ref<RouteRecordName | null>(null)

      watch(
        () => route.name,
        (to, from) => {
          routeFromName.value = from
        }
      )

      provide(
        'previousRouteName',
        computed(() => routeFromName.value)
      )
    },
  })

  app.config.compilerOptions.delimiters = ['[[', ']]']

  const pinia = createPinia()
  
  const router = createAppRouter({
    app,
    createInstance: createRouterInstance,
    createWebHistory,
    pinia,
  })

  app
    .use(install)
    .component('HelloWorld', HelloWorld)
    .use(pinia)
    .use(pinia)
    .use(i18n)
    .use(router)
    .use(Components)
    .use(Modules)
    .use(Plugins)
    // .use(Icons)
    .mount('#app')

  return app
}
